/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.billing.contracts'},
});

const ContractsItem = () => (
  <RouteLinkItem
    route="midas/settings/billing/contracts"
    title={messages.title}
  />
);

export default ContractsItem;
